import React, { useState } from "react";
import EditIcon from "../../images/edit.svg";
import PlusIcon from "../../images/plus.svg";
import TrashIcon from "../../images/trash.svg";
import { Product } from "../../models/ticket";
import { formatCurrency } from "../../utils/formatCurrency";
import { ContainerAddProduct } from "../ContainerAddProduct";
import { StoresListSelect } from "../StoresListSelect";
import { TotalValueProducts } from "../TotalValueProducts";

interface Step3Props {
  handleChange: any;
  errors: any;
  values: any;
  listProducts: Product[];
  handleProducts: (data: Product) => void;
  handleDeleteProducts: (id: number) => void;
  setValues: any;
}

export function Step3({
  errors,
  handleChange,
  values,
  listProducts,
  handleProducts,
  handleDeleteProducts,
  setValues,
}: Step3Props) {
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [editingId, setEditingId] = useState<number>();
  const [newProduct, setNewProduct] = useState<Product>({
    name: "",
    price: 0,
    quantity: 0,
    id: 0,
  });

  function handleEdit(product: Product) {
    setShowEdit(true);
    setEditingId(product.id);
    setNewProduct(product);
  }

  return (
    <div>
      <StoresListSelect
        name="store"
        label="Nome da loja"
        onChange={handleChange}
        error={errors.store}
        value={values.store}
      />

      {listProducts.map(({ name, price, quantity, id }) => {
        if (showEdit && editingId === id) {
          return (
            <ContainerAddProduct
              handleChange={handleChange}
              newProduct={newProduct}
              setNewProduct={setNewProduct}
              handleProducts={handleProducts}
              setShowEdit={setShowEdit}
              showEdit={showEdit}
              setShowAdd={setShowAdd}
              setValues={setValues}
              values={values}
            />
          );
        }

        return (
          <div className="listItem" key={id}>
            <div>
              <p className="title">{`${quantity}x ${name}`}</p>
              <p className="price">{formatCurrency(price)}</p>
            </div>

            <div className="actionButtonsContainer">
              <button type="button" onClick={() => handleDeleteProducts(id)}>
                <img src={TrashIcon} alt="Trash Icon" />
              </button>
              <button
                type="button"
                onClick={() => handleEdit({ name, price, quantity, id })}
              >
                <img src={EditIcon} alt="Edit Icon" />
              </button>
            </div>
          </div>
        );
      })}

      {(listProducts.length === 0 || showAdd) && (
        <ContainerAddProduct
          handleChange={handleChange}
          newProduct={newProduct}
          setNewProduct={setNewProduct}
          handleProducts={handleProducts}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          setShowAdd={setShowAdd}
          setValues={setValues}
          values={values}
        />
      )}

      <TotalValueProducts listProducts={listProducts} />

      <button
        className="buttonAddProduct ghost button"
        type="button"
        onClick={() => setShowAdd(true)}
        disabled={showEdit || showAdd}
      >
        <img src={PlusIcon} alt="Plus Icon" />
        Adicionar novos produtos
      </button>
    </div>
  );
}
